import React from "react";
import { Package } from "lucide-react";

export const ProdutosLista = ({ produtos }) => {
  if (!produtos || produtos.length < 2) return null;
  return (
    <div className="mt-2 border border-border bg-[#FAFAFA] p-3" data-testid="produtos-lista">
      <div className="text-[10px] font-bold uppercase tracking-wider text-[#142766] mb-2 flex items-center gap-1">
        <Package size={12} /> Itens do pedido ({produtos.length})
      </div>
      <ul className="space-y-1">
        {produtos.map((p, i) => (
          <li key={i} className="text-xs flex items-start gap-2" data-testid={`produto-item-${i}`}>
            <span className="font-bold text-[#FF6700] shrink-0">{i + 1}.</span>
            <span className="flex-1">
              {p.produto}
              {p.cor && <span className="text-muted-foreground"> · {p.cor}</span>}
              {p.marca && <span className="text-muted-foreground"> · {p.marca}</span>}
            </span>
            <span className="font-bold shrink-0">x{p.quantidade || 1}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProdutosLista;
